// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Km4R","toggle":"styles_toggle__3NXnn","preview":"styles_preview__38Inm"};